import { IonButton, IonButtons, IonMenuToggle } from '@ionic/react';
import { useUserState } from '../../../hooks/context/useUserState';
import MenuIcon from '../../../icons/menu.svg';

const MenuButton = () => {
  const {
    state: { username },
  } = useUserState();

  if (!username) return null;

  return (
    <IonButtons slot="start">
      <IonMenuToggle className="sidebar-button">
        <IonButton>
          <img src={MenuIcon} alt="Open sidebar" />
        </IonButton>
      </IonMenuToggle>
    </IonButtons>
  );
};

export default MenuButton;
